export default __webpack_public_path__ + "static/media/hotJobsIcon.ce2d5c55.svg";